export const LANGUAGE_CODE = {
  ENGLISH: 'en-US',
  TRADITIONAL_CHINESE: 'zh-TW',
  CHINESE: 'zh-CN',
  ARABIC: 'ar-SA',
  HEBREW: 'he-IL',
  FRENCH: 'fr-FR',
  GERMAN: 'de-DE',
  HINDI: 'hi-IN',
  JAPANESE: 'ja-JP',
  KOREAN: 'ko-KR',
  PORTUGUESE: 'pt-BR',
  RUSSIAN: 'ru-RU',
  SPANISH: 'es-MX',
  INDONESIAN: 'id-ID',
  UKRAINIAN: 'uk-UA',
  THAI: 'th-TH',
  ITALIAN: 'it-IT',
  BULGARIAN: 'bg-BG',
  POLISH: 'pl-PL',
  TURKISH: 'tr-TR',
  ROMANIAN: 'ro-RO',
  CZECH: 'cs-CZ',
  HUNGARIAN: 'hu-HU',
  DUTCH: 'nl-NL',
  DANISH: 'da-DK',
  GREEK: 'el-GR',
  MALAY: 'ms-MY',
  ESTONIAN: 'et-EE',
  FINNISH: 'fi-FI',
  CROATIAN: 'hr-HR',
  LITHUANIAN: 'lt-LT',
  LATVIAN: 'lv-LV',
  ENGLISH_UK: 'en-GB',
  NORWEGIAN: 'no-NO',
  SLOVAK: 'sk-SK',
  SLOVENIAN: 'sl-SI',
  SWEDISH: 'sv-SE',
  AZERBAIJANI: 'az-AZ',
  KAZAKH: 'kk-KZ',
  ARMENIAN: 'hy-AM',
  BOSNIAN: 'bs-BA',
  EUROPEANSPANISH: 'es-ES',
  CANTONESE: 'zh-HK',
  EUROPEANPORTUGUESE: 'pt-PT',
  PERSIAN: 'fa-IR',
  GEORGIAN: 'ka-GE',
};
// Native Name
export const LANGUAGE_NAME_TRANSLATED = {
  [LANGUAGE_CODE.ENGLISH]: 'English',
  [LANGUAGE_CODE.TRADITIONAL_CHINESE]: '繁體中文',
  [LANGUAGE_CODE.CHINESE]: '简体中文',
  [LANGUAGE_CODE.ARABIC]: 'العَرَبِية',
  [LANGUAGE_CODE.HEBREW]: 'עברית',
  [LANGUAGE_CODE.FRENCH]: 'Français',
  [LANGUAGE_CODE.GERMAN]: 'Deutsch',
  [LANGUAGE_CODE.HINDI]: 'हिंदी',
  [LANGUAGE_CODE.JAPANESE]: '日本語',
  [LANGUAGE_CODE.KOREAN]: '한국어',
  [LANGUAGE_CODE.PORTUGUESE]: 'Português',
  [LANGUAGE_CODE.RUSSIAN]: 'Русский',
  [LANGUAGE_CODE.SPANISH]: 'Español',
  [LANGUAGE_CODE.INDONESIAN]: 'Bahasa Indonesia',
  [LANGUAGE_CODE.UKRAINIAN]: 'Українська',
  [LANGUAGE_CODE.THAI]: 'ภาษาไทย',
  [LANGUAGE_CODE.ITALIAN]: 'Italiano',
  [LANGUAGE_CODE.ROMANIAN]: 'Română',
  [LANGUAGE_CODE.CZECH]: 'čeština',
  [LANGUAGE_CODE.HUNGARIAN]: 'Magyar',
  [LANGUAGE_CODE.DUTCH]: 'Nederlands',
  [LANGUAGE_CODE.DANISH]: 'Dansk',
  [LANGUAGE_CODE.GREEK]: 'ελληνικά',
  [LANGUAGE_CODE.MALAY]: 'Melayu',
  [LANGUAGE_CODE.ESTONIAN]: 'Eesti',
  [LANGUAGE_CODE.FINNISH]: 'Suomi',
  [LANGUAGE_CODE.CROATIAN]: 'Hrvatski',
  [LANGUAGE_CODE.LITHUANIAN]: 'Lietuvių',
  [LANGUAGE_CODE.LATVIAN]: 'Latviešu',
  [LANGUAGE_CODE.ENGLISH_UK]: 'English GB',
  [LANGUAGE_CODE.NORWEGIAN]: 'Norsk',
  [LANGUAGE_CODE.SLOVAK]: 'Slovenčina',
  [LANGUAGE_CODE.SLOVENIAN]: 'Slovenščina',
  [LANGUAGE_CODE.SWEDISH]: 'Svenska',
  [LANGUAGE_CODE.AZERBAIJANI]: 'Azərbaycan dili',
  [LANGUAGE_CODE.KAZAKH]: 'Қазақ тілі',
  [LANGUAGE_CODE.ARMENIAN]: 'Հայերեն',
  [LANGUAGE_CODE.BOSNIAN]: 'Bosanski',
  [LANGUAGE_CODE.EUROPEANSPANISH]: 'Espanhol Europeu',
  [LANGUAGE_CODE.CANTONESE]: '粵語',
  [LANGUAGE_CODE.EUROPEANPORTUGUESE]: 'Português Europeu',
  [LANGUAGE_CODE.PERSIAN]: 'فارسی',
  [LANGUAGE_CODE.GEORGIAN]: 'ქართული ენა',
  [LANGUAGE_CODE.HINDI]: 'Հայերեն',
};
//ad hoc：Language
export const LANGUAGE_TRANSLATED = {
  [LANGUAGE_CODE.ENGLISH]: 'Language',
  [LANGUAGE_CODE.TRADITIONAL_CHINESE]: '語言',
  [LANGUAGE_CODE.CHINESE]: '语言',
  [LANGUAGE_CODE.ARABIC]: 'اللغة',
  [LANGUAGE_CODE.HEBREW]: 'שפה',
  [LANGUAGE_CODE.FRENCH]: 'Langue',
  [LANGUAGE_CODE.GERMAN]: 'Sprache',
  [LANGUAGE_CODE.HINDI]: 'हिंदी',
  [LANGUAGE_CODE.JAPANESE]: '言語',
  [LANGUAGE_CODE.KOREAN]: '언어',
  [LANGUAGE_CODE.PORTUGUESE]: 'Idioma',
  [LANGUAGE_CODE.RUSSIAN]: 'Язык',
  [LANGUAGE_CODE.SPANISH]: 'Idioma',
  [LANGUAGE_CODE.INDONESIAN]: 'Bahasa',
  [LANGUAGE_CODE.UKRAINIAN]: 'Мова',
  [LANGUAGE_CODE.THAI]: 'ภาษา',
  [LANGUAGE_CODE.ITALIAN]: 'Lingua',
  [LANGUAGE_CODE.ROMANIAN]: 'Limbă',
  [LANGUAGE_CODE.CZECH]: 'Jazyk',
  [LANGUAGE_CODE.HUNGARIAN]: 'Nyelv',
  [LANGUAGE_CODE.DUTCH]: 'Taal',
  [LANGUAGE_CODE.DANISH]: 'Sprog',
  [LANGUAGE_CODE.GREEK]: 'Γλώσσα',
  [LANGUAGE_CODE.MALAY]: 'Bahasa',
  [LANGUAGE_CODE.ESTONIAN]: 'Keel',
  [LANGUAGE_CODE.FINNISH]: 'Kieli',
  [LANGUAGE_CODE.CROATIAN]: 'Jezik',
  [LANGUAGE_CODE.LITHUANIAN]: 'Kalba',
  [LANGUAGE_CODE.LATVIAN]: 'Valoda',
  [LANGUAGE_CODE.ENGLISH_UK]: 'Language',
  [LANGUAGE_CODE.NORWEGIAN]: 'Språk',
  [LANGUAGE_CODE.SLOVAK]: 'Jazyk',
  [LANGUAGE_CODE.SLOVENIAN]: 'Jezik',
  [LANGUAGE_CODE.SWEDISH]: 'Språk',
  [LANGUAGE_CODE.AZERBAIJANI]: 'Dil',
  [LANGUAGE_CODE.KAZAKH]: 'Тіл',
  [LANGUAGE_CODE.ARMENIAN]: 'Լեզու',
  [LANGUAGE_CODE.BOSNIAN]: 'Jezik',
  [LANGUAGE_CODE.EUROPEANSPANISH]: 'Idioma',
  [LANGUAGE_CODE.CANTONESE]: '語言',
  [LANGUAGE_CODE.EUROPEANPORTUGUESE]: 'Idioma',
  [LANGUAGE_CODE.PERSIAN]: 'زبان',
  [LANGUAGE_CODE.GEORGIAN]: 'ენა',
  [LANGUAGE_CODE.HINDI]: 'भाषा',
};
